import Button from '@jetbrains/ring-ui/components/button/button'
import Link from '@jetbrains/ring-ui/components/link/link'
import classNames from 'classnames'
import {memo} from 'react'

import TransformText from '../../../../../containers/TransformText'
import ValueToClickAction from '../../../../common/ValueToClickAction/ValueToClickAction'

import type {ItemOwnProps} from './TestMetadataPopup.types'
import {getFileName, getSrcLink, getName} from './TestMetadataPopup.utils'

import styles from './TestMetadataPopup.css'

function TestMetadataItem({
  buildTypeId,
  buildId,
  metadata,
  withBoldValue,
  showTestMetadataGraph,
}: ItemOwnProps) {
  const {value = '', type} = metadata
  const name = getName(metadata)

  if (type === 'text') {
    return (
      <>
        {name != null && (
          <span className={styles.name} title={name}>
            {name}
            {': '}
          </span>
        )}
        <span
          className={classNames(styles.text, {
            [styles.bold]: name == null && withBoldValue,
          })}
        >
          <TransformText TagName="span" buildTypeId={buildTypeId} text={value} />
        </span>
      </>
    )
  }

  if (type === 'artifact') {
    const link = getSrcLink(value, buildTypeId, buildId)
    const fileName = getFileName(metadata)
    return (
      <>
        {name != null && (
          <span className={styles.name} title={name}>
            {name}
            {': '}
          </span>
        )}
        <Link
          target="_blank"
          rel="noreferrer"
          href={link}
          className={classNames(styles.artifact, {
            [styles.bold]: name == null && withBoldValue,
          })}
        >
          {fileName}
        </Link>
      </>
    )
  }

  if (type === 'link') {
    return (
      <Link
        href={value}
        className={classNames(styles.link, {
          [styles.bold]: withBoldValue,
        })}
      >
        {name != null ? name : value}
      </Link>
    )
  }

  if (['number', 'ms', 'bytes', 'percent'].includes(type as string)) {
    return (
      <>
        {name != null && (
          <span className={styles.name} title={name}>
            {name}
            {': '}
          </span>
        )}
        <div
          className={classNames(styles.number, {
            [styles.bold]: name == null && withBoldValue,
          })}
        >
          <span>{value != null && value !== '' ? Number(value) : 'Undefined'}</span>
          <ValueToClickAction
            onClick={showTestMetadataGraph}
            value={metadata.name}
            child={
              <Button className={styles.showGraph} title="View metric graph" text>
                {'Show graph'}
              </Button>
            }
          />
        </div>
      </>
    )
  }

  if (type === 'image') {
    const link = getSrcLink(value, buildTypeId, buildId)
    const fileName = getFileName(metadata)
    return (
      <>
        <div className={styles.itemHeading}>
          <div className={styles.name} title={name}>
            {name != null ? name : fileName}
          </div>
          {name != null && (
            <div className={styles.fileName} title={`File name: ${fileName}`}>
              {fileName}
            </div>
          )}
        </div>
        <a href={link} target="_blank" rel="noreferrer">
          <img className={styles.image} src={link} alt={fileName} />
        </a>
      </>
    )
  }

  if (type === 'video') {
    const link = getSrcLink(value, buildTypeId, buildId)
    const fileName = getFileName(metadata)
    return (
      <>
        <div className={styles.itemHeading}>
          <div className={styles.name} title={name}>
            {name != null ? name : fileName}
          </div>
          {name != null && (
            <div className={styles.fileName} title={`File name: ${fileName}`}>
              {fileName}
            </div>
          )}
        </div>
        <a href={link} target="_blank" rel="noreferrer">
          {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
          <video className={styles.video} src={link} controls />
        </a>
      </>
    )
  }

  return null
}

export default memo<ItemOwnProps>(TestMetadataItem)
